module.exports = __webpack_public_path__ + "static/media/ibd_back3.f0ce4d52.png";